import React, { useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  FormControl,
  TextField,
} from "@mui/material";

const RefillsModal = ({ open, onClose, onSubmit }) => {
  const [dob, setDob] = useState("");
  const [rxNumber, setRxNumber] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(null);

  // Validate that the RX number is 6-12 digits
  const isValidRx = /^[0-9]{5,12}$/.test(rxNumber);

  // Ensure required fields are provided and RX is valid
  const isValidForm = dob.trim() !== "" && isValidRx;

  const handleSubmit = async () => {
    if (!isValidForm) return;
    try {
      const response = await onSubmit({
        date_of_birth: dob,
        rx_number: rxNumber,
      });

      if (response.ok) {
        setSubmissionStatus("success");
      } else {
        setSubmissionStatus("failure");
      }
    } catch (error) {
      console.error("Error submitting refill request:", error);
      setSubmissionStatus("failure");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" mb={2}>
          Submit a Refill or Renewal
        </Typography>
        {submissionStatus ? (
          submissionStatus === "success" ? (
            <>
              <Typography mb={2}>
                Your refill request has been submitted successfully!
              </Typography>
              <Button onClick={onClose} variant="contained" color="primary">
                Close
              </Button>
            </>
          ) : (
            <>
              <Typography mb={2}>
                Submission failed. Please try again later.
              </Typography>
              <Button onClick={onClose} variant="contained" color="primary">
                Close
              </Button>
            </>
          )
        ) : (
          <>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Date of Birth"
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: new Date().toISOString().split("T")[0] }}
                required
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Prescription RX Number"
                value={rxNumber}
                onChange={(e) => setRxNumber(e.target.value)}
                error={rxNumber.length > 0 && !isValidRx}
                helperText={
                  rxNumber.length > 0 && !isValidRx
                    ? "RX numbers must be 5-12 digits"
                    : ""
                }
                required
              />
            </FormControl>

            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              disabled={!isValidForm}
            >
              Submit
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

export default RefillsModal;
